import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../theme';
import { useTranslation } from 'react-i18next';
import MediaQuery from '../MediaQuery/MediaQuery';
import Disclaimer from './сomponents/Disclaimer/Disclaimer';
import Tooltip from '@mui/material/Tooltip';
import Header from '../BaseComponents/Header';
import ConditionsModal from '../Modules/Checkin/components/Checkin/ConditionsModal/ConditionsModal';

interface Props {
	service: 'seat' | 'baggage' | 'meal' | 'extras' | 'checkin';
	disclaimer?: string;
}

const AdditionalServiceBanner: React.FunctionComponent<Props> = ({ service, disclaimer }) => {
	const css = useTheme('AdditionalServiceBanner').AdditionalServiceBannerStyles;
	const { t } = useTranslation();

	return (
		<Header
			className={css.container}
			classes={{
				inner: css.inner
			}}
			equalSlotsBasis={false}
			showEmptySlots={false}
			center={
				<div
					className={cn(css.wrapper, {
						[css.baggageBanner]: service === 'baggage',
						[css.mealBanner]: service === 'meal',
						[css.seatBanner]: service === 'seat',
						[css.extrasBanner]: service === 'extras',
						[css.checkinBanner]: service === 'checkin'
					})}
				>
					<div className={css.content}>
						<div className={css.text}>
							<MediaQuery minWidth={'tablet'}>
								{t(
									service === 'baggage'
										? 'BaggagePage:Transportation of impressions no limitations'
										: service === 'seat'
										? 'SeatMap:The top ones get the top seats. Be on top!'
										: service === 'meal'
										? 'MealPage:Feel the taste in flight'
										: service === 'checkin'
										? 'Checkin:Online check-in'
										: 'Checkin:Anything else for your trip?'
								)}
							</MediaQuery>
							<MediaQuery maxWidth={'tablet'}>
								{t(
									service === 'baggage'
										? 'BaggagePage:Baggage'
										: service === 'seat'
										? 'SeatMap:Seats'
										: service === 'meal'
										? 'MealPage:Meal'
										: service === 'checkin'
										? 'Checkin:Online check-in'
										: 'Checkin:Anything else for your trip?'
								)}
							</MediaQuery>
							{service !== 'extras' && (
								<div className={css.additional}>
									{service === 'checkin' ? (
										<ConditionsModal className={css.conditionsModal} />
									) : !!disclaimer ? (
										<Tooltip
											title={disclaimer}
											placement="bottom"
											classes={{ tooltip: css.tooltip }}
										>
											<div className={css.disclaimer__wrapper}>
												<Disclaimer service={service} />
											</div>
										</Tooltip>
									) : (
										<Disclaimer service={service} />
									)}
								</div>
							)}
						</div>
					</div>

					<div className={css.image} />
					<div className={css.whiteLines}>
						<div className={css.whiteLine_wide} />
						<div className={css.whiteLine_narrow} />
					</div>
				</div>
			}
		/>
	);
};

export default AdditionalServiceBanner;
